/*
 * Copyright 2022, TeamDev. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Redistribution and use in source and/or binary forms, with or without
 * modification, must retain the above copyright notice and the following
 * disclaimer.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpineError = exports.ServerError = exports.ConnectionError = exports.CommandValidationError = exports.CommandHandlingError = exports.ClientError = void 0;

var _error_pb = require("../proto/spine/base/error_pb");

var _validation_error_pb = require("../proto/spine/validate/validation_error_pb");

var _typedMessage = require("./typed-message");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = Reflect.construct(cls, Array.from(arguments));
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    return instance;
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

/**
 * The base error type of Spine Web. This error type is only used directly when a
 * more appropriate category is not defined for the offending error.
 *
 * @extends Error
*/
var SpineError = /*#__PURE__*/function (_extendableBuiltin2) {
  _inherits(SpineError, _extendableBuiltin2);

  var _super = _createSuper(SpineError);

  /**
   * @param {!string} message the human-readable error message
   * @param {*=} cause        the reason why this error occurred
   */
  function SpineError(message, cause) {
    var _this;

    _classCallCheck(this, SpineError);

    _this = _super.call(this, message);
    _this.name = _this.constructor.name;
    _this._cause = cause;
    return _this;
  }
  /**
   * @return {*|undefined} The cause of this error, if available.
   */


  _createClass(SpineError, [{
    key: "getCause",
    value: function getCause() {
      return this._cause;
    }
  }]);

  return SpineError;
}(_extendableBuiltin(Error));
/**
 * An error which occurs when sending off a request to Spine server endpoint fails due to the
 * connection problems.
 *
 * Can be caused by an incorrect server address, lack of network connectivity or
 * if the response is not received from the server.
 *
 * @extends SpineError
 */


exports.SpineError = SpineError;

var ConnectionError = /*#__PURE__*/function (_SpineError) {
  _inherits(ConnectionError, _SpineError);

  var _super2 = _createSuper(ConnectionError);

  /**
   * @param {!Error} error the error caught from {@code fetch} invocation
   */
  function ConnectionError(error) {
    _classCallCheck(this, ConnectionError);

    return _super2.call(this, error.message, error);
  }

  return _createClass(ConnectionError);
}(SpineError);
/**
 * An error which occurs when sending off a request to Spine server endpoint results
 * with a response with `5xx` status code.
 *
 * @extends SpineError
 */


exports.ConnectionError = ConnectionError;

var ServerError = /*#__PURE__*/function (_SpineError2) {
  _inherits(ServerError, _SpineError2);

  var _super3 = _createSuper(ServerError);

  /**
   * @param {!Response} response the server response caused this error
   */
  function ServerError(response) {
    _classCallCheck(this, ServerError);

    return _super3.call(this, response.statusText, response);
  }

  return _createClass(ServerError);
}(SpineError);
/**
 * An error which occurs when sending off a request to Spine server endpoint results
 * with a response with `4xx` status code.
 *
 * @extends SpineError
 */


exports.ServerError = ServerError;

var ClientError = /*#__PURE__*/function (_SpineError3) {
  _inherits(ClientError, _SpineError3);

  var _super4 = _createSuper(ClientError);

  /**
   * @param {!string} message the human-readable error message
   * @param {*=} cause        the reason why this error occurred
   */
  function ClientError(message, cause) {
    _classCallCheck(this, ClientError);

    return _super4.call(this, message, cause);
  }

  return _createClass(ClientError);
}(SpineError);
/**
 * An error which occurs when sending off a command to Spine server endpoint.
 *
 * @extends SpineError
 */


exports.ClientError = ClientError;

var CommandHandlingError = /*#__PURE__*/function (_SpineError4) {
  _inherits(CommandHandlingError, _SpineError4);

  var _super5 = _createSuper(CommandHandlingError);

  /**
   * @param {!string} message the human-readable error message
   * @param {!Error|SpineError|SpineBaseError} error the reason why this error occurred
   */
  function CommandHandlingError(message, error) {
    _classCallCheck(this, CommandHandlingError);

    return _super5.call(this, message, error);
  }
  /**
   * Returns `true` if the command wasn't accepted by the server; returns `false`
   * if this is not guaranteed.
   *
   * A command is assumed neglected if this error is caused by the `ClientError`
   * or the `SpineBaseError`.
   *
   * @return {boolean}
   */


  _createClass(CommandHandlingError, [{
    key: "assuresCommandNeglected",
    value: function assuresCommandNeglected() {
      var cause = this.getCause();
      return cause instanceof ClientError || (0, _typedMessage.isProtobufMessage)(cause) && cause.constructor.typeUrl() === _error_pb.Error.typeUrl();
    }
  }]);

  return CommandHandlingError;
}(SpineError);
/**
 * An error which occurs when sending off a command to Spine server endpoint results
 * with a response indicating that a command message was rejected further processing
 * because of a validation error.
 *
 * @extends CommandHandlingError
 */


exports.CommandHandlingError = CommandHandlingError;

var CommandValidationError = /*#__PURE__*/function (_CommandHandlingError) {
  _inherits(CommandValidationError, _CommandHandlingError);

  var _super6 = _createSuper(CommandValidationError);

  /**
   * @param {!string} message the human-readable error message
   * @param {!SpineBaseError} error the command validation error
   */
  function CommandValidationError(message, error) {
    _classCallCheck(this, CommandValidationError);

    return _super6.call(this, message, error);
  }
  /**
   * @return {ValidationError} command validation error
   */


  _createClass(CommandValidationError, [{
    key: "validationError",
    value: function validationError() {
      return this.getCause().getValidationError();
    }
  }]);

  return CommandValidationError;
}(CommandHandlingError);

exports.CommandValidationError = CommandValidationError;
//# sourceMappingURL=errors.js.map